import { LOGOUT } from 'actions';
import { tryLocalStorageRemoveItem } from 'utils/localStorage';

export function logout() {
  tryLocalStorageRemoveItem('userToken');
  window.dispatchEvent(new Event('storage'));

  return { type: LOGOUT };
}
